enum FeeDefintionType {
    Manual = 1,
    Monthly = 2
}
export default FeeDefintionType